import * as React from 'react';
import { Select, SelectProps } from '../inputs/Select';
import { FormField } from './FormField';

type SelectFieldProps = SelectProps & {
    label:string,
    width?:string,
    minWidth?:string,
    inErrorState?:boolean,
    message?:string,
    toolTip?:React.ReactNode
};

export function SelectField(props:SelectFieldProps)
{
    return (
        <FormField
            toolTip={props.toolTip}
            label={props.label} 
            inputComponent={
                <Select {...props} />
            }
            inErrorState={props.inErrorState}
            message={props.message}
        />
    )
}